export enum PaymentMethod {
  CREDIT_CARD = 'CreditCard',
  PAY_PAL = 'PayPal',
  ALTERNATIVE = 'Alternative',
  MANUAL = 'Manual',
  TWO_CREDIT_CARDS = 'TwoCreditCards',
}

export enum PaymentMethodOnFile {
  EXISTING = 'existingPaymentMethod',
  NEW = 'newPaymentMethod',
}
